import { render, staticRenderFns } from "./ExcluirConta.vue?vue&type=template&id=a90ecc64&scoped=true"
import script from "./ExcluirConta.vue?vue&type=script&lang=js"
export * from "./ExcluirConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ecc64",
  null
  
)

export default component.exports